import { ControlLink, Stack } from '@moda/om';
import classNames from 'classnames';
import React from 'react';
import { useMobileNavigator } from '../../../hooks/useNavigator';

import './MobileNavHeader.scss';

interface Props {
  onChange: (index: number) => void;
  selectedTabIndex: number;
}

export const MobileNavHeader: React.FC<Props> = ({ onChange, selectedTabIndex }) => {
  const { data: verticals } = useMobileNavigator();

  if (!verticals) return null;

  return (
    <Stack
      className="MobileNavHeader"
      direction="horizontal"
      justifyContent="space-between"
      space={0}
    >
      {verticals.map(({ title }, index) => (
        <div
          className={classNames('MobileNavHeader__tab', {
            'MobileNavHeader__tab--selected': selectedTabIndex == index,
            'MobileNavHeader__tab--two-items': verticals.length === 2,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            'MobileNavHeader__tab--three-items': verticals.length === 3,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            'MobileNavHeader__tab--four-items': verticals.length === 4
          })}
          onClick={() => onChange(index)}
          onKeyDown={() => onChange(index)}
          key={`${title} -- ${index}`}
          role="button"
          tabIndex={selectedTabIndex === index ? -1 : 0}
        >
          <ControlLink underlined={selectedTabIndex === index}>{title.toUpperCase()}</ControlLink>
        </div>
      ))}
    </Stack>
  );
};
